import { UserTypeEnum } from '@/@data'
import * as yup from 'yup'

export const getInformationSchema = (__: (key: string) => string, type?: UserTypeEnum) => {
  return yup.object().shape({
    // @ts-ignore
    company_id: [UserTypeEnum.Agent, UserTypeEnum.Admin].includes(type)
      ? yup.string().required(__('Branch is required'))
      : null,
    first_name: yup.string().required(__('Name is required')),
    email: yup.string().email(__('Invalid email')).required(__('Email is required'))
  })
}

export const getAuthenticationSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    verification_code: yup
      .string()
      .min(6, __('Verification code must be 6 characters'))
      .max(6, __('Verification code must be 6 characters'))
      .required(__('Verification code is required'))
  })
}

export const getSignatureSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    // passport_front: yup.mixed().required(__('Passport front is required')),
    // passport_back: yup.mixed().required(__('Passport back is required')),
    // signature: yup.string().required(__('Signature is required'))
  })
}

export const getPasswordSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    password: yup
      .string()
      .min(6, __('Password must be at least 6 characters'))
      .matches(/[0-9]/, __('Password must contain at least one number'))
      .required(__('Password is required')),
    confirm_password: yup
      .string()
      .oneOf([yup.ref('password')], __('New password and confirmation do not match.'))
      .required(__('Confirm password is required'))
  })
}

export const getTwoFactorSchema = (__: (key: string) => string) => {
  return yup.object().shape({
    two_fa_otp: yup
      .string()
      .min(6, __('Password must be at least 6 characters'))
      .max(6, __('Password must be at least 6 characters'))
      .required(__('2FA code is required'))
  })
}

export const getAgentRegistrationSchema = (__: (key: string) => string, type: UserTypeEnum) => {
  return yup.object().shape({
    ...getInformationSchema(__, type).fields,
    ...getAuthenticationSchema(__).fields,
    ...getSignatureSchema(__).fields,
    ...getPasswordSchema(__).fields,
    ...getTwoFactorSchema(__).fields
  })
}
